import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const CheckFile = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 14 14">
    <path d="M2.33341 12.25C2.01258 12.25 1.73793 12.1358 1.50946 11.9073C1.28098 11.6788 1.16675 11.4042 1.16675 11.0833V2.91667C1.16675 2.59583 1.28098 2.32118 1.50946 2.09271C1.73793 1.86424 2.01258 1.75 2.33341 1.75H11.6667C11.9876 1.75 12.2622 1.86424 12.4907 2.09271C12.7192 2.32118 12.8334 2.59583 12.8334 2.91667V11.0833C12.8334 11.4042 12.7192 11.6788 12.4907 11.9073C12.2622 12.1358 11.9876 12.25 11.6667 12.25H2.33341ZM2.33341 11.0833H11.6667V2.91667H2.33341V11.0833ZM2.91675 9.91667H5.83341V8.75H2.91675V9.91667ZM8.48758 8.75L11.3751 5.8625L10.5438 5.03125L8.48758 7.10208L7.65633 6.27083L6.83966 7.10208L8.48758 8.75ZM2.91675 7.58333H5.83341V6.41667H2.91675V7.58333ZM2.91675 5.25H5.83341V4.08333H2.91675V5.25Z" />
  </SvgIcon>
));

CheckFile.displayName = 'CheckFile';

export default CheckFile;
